import { FormHook } from "./hooks/form/Form";
import { schemaProdep } from "./validations/prodep";
export const prodepInitialState = {
  id_professor: "",
  professor: "",
  grade: "",
  program: "",
  region: "",
  procedure: "",
  students: [
    {
      matricula: "",
      student: "",
      title: "",
      type: "",
      result: "",
      date: "",
    },
  ],
};
// export const prodepInitialState = {
//   id_professor: "zs234234",
//   professor: "Carlos ruz",
//   grade: 1,
//   program: 1,
//   region: 1,
//   procedure: 1,
//   students: [
//     {
//       matricula: "ZS098098098",
//       student: "PERLA PATRICIA VELAZQUEZ CONTRERAS",
//       title: "Gestacion subrogada, regularla o prohibirla",
//       type: 1,
//       result: "100",
//       date: "",
//     },
//   ],
// };

export const prodepStudent = {
  matricula: "",
  student: "",
  title: "",
  type: "",
  result: "",
};

export default function FieldsProdep(data = prodepInitialState) {
  return FormHook(data, schemaProdep);
}
